import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ReactQuill from 'react-quill';
import { Dialog } from '@progress/kendo-react-dialogs';
import { palette } from '../../../system/styles/styles';

const TermsAndConditions = ({ open, close, TermsAndConditions, className }) => {
  const [state, setState] = useState({
    terms: '',
    privacy: '',
  });

  const platform = useSelector((state) => state.platform);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      terms: platform.TermsAndConditions,
      privacy: platform.Privacy,
    }));
  }, [platform]);

  if (!open) return null;

  return (
    <Dialog
      onClose={close}
      title={
        TermsAndConditions
          ? 'Estos son nuestros términos y condiciones de uso'
          : 'Puedes revisar nuestro aviso de privacidad'
      }>
      <div className={className}>
        <div className="terms-modal-container">
          <div className="terms-container">
            {open ? (
              <ReactQuill
                className="terms-conditions"
                value={TermsAndConditions ? state.terms : state.privacy}
                readOnly
                theme="bubble"
              />
            ) : null}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default styled(TermsAndConditions)`
  position: relative;
  width: 70%;
  margin: 10px auto;
  overflow-y: auto;
  height: 85vh;
  background-color: rgba(255, 255, 255, 0.5);
  border: 2px solid #000;
  box-shadow: ${palette.lightBS};
  padding: 16px;
  outline: none;
  @media screen and (max-width: 720px) {
    width: 95%;
    height: 90vh;
  }
  .modalHead {
    display: flex;
    padding: 10px 20px;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  .closeIcon {
    font-size: 2.5rem !important;
    color: black;
    position: absolute;
    left: calc(100% - 2.5rem);
    top: 1rem;
  }
`;
